import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import graphqlClient from "@/GQLClient";
import {
  DeleteMeetingAgendaPointTemplateDocument,
  GetMeetingAgendaPointTemplatesDocument,
  SaveMeetingAgendaPointTemplateDocument,
  type MeetingAgendaPointTemplate,
  type MeetingAgendaPointTemplateInput,
} from "@/graphql/generated-types";

const getAll = async (): Promise<MeetingAgendaPointTemplate[]> => {
  const response = await graphqlClient.query({
    query: GetMeetingAgendaPointTemplatesDocument,
    variables: {
      filter: {
        first: 1000,
      },
    },
  });

  if (
    response.data.institutions?.getMyInstitution?.meetingAgendaPointTemplates
  ) {
    return response.data.institutions.getMyInstitution.meetingAgendaPointTemplates.edges
      .map((item) => item.node)
      .filter((node) => node.__typename === "MeetingAgendaPointTemplate")
      .map((node) => node as MeetingAgendaPointTemplate)
      .sort((a, b) => a.title.localeCompare(b.title));
  }

  throw new SentryGraphQLError("meetingAgendaPoints.getAll");
};

const save = async (agendaPoint: MeetingAgendaPointTemplateInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveMeetingAgendaPointTemplateDocument,
    variables: {
      agendaPoint,
    },
  });

  if (response.data?.meeting?.saveAgendaPointTemplate?.success) {
    return response.data.meeting.saveAgendaPointTemplate;
  }

  throw new SentryGraphQLError("meetingAgendaPoints.save");
};

const deleteItem = async (id: string) => {
  const response = await graphqlClient.mutate({
    mutation: DeleteMeetingAgendaPointTemplateDocument,
    variables: {
      id,
    },
  });

  if (response.data?.meeting?.deleteAgendaPointTemplate?.success) {
    return response.data.meeting.deleteAgendaPointTemplate;
  }

  throw new SentryGraphQLError("meetingAgendaPoints.deleteItem");
};

export default {
  getAll,
  save,
  deleteItem,
};
